// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAvailableBalanceTypePropertyDto
 */
export interface IAvailableBalanceTypePropertyDto {
    /**
     * 
     * @type {string}
     * @memberof IAvailableBalanceTypePropertyDto
     */
    available_balance_type?: IAvailableBalanceTypePropertyDtoAvailableBalanceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IAvailableBalanceTypePropertyDto
     */
    available_balance_type_state?: IAvailableBalanceTypePropertyDtoAvailableBalanceTypeStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IAvailableBalanceTypePropertyDtoAvailableBalanceTypeEnum {
    ACTUAL_BALANCE = 'ACTUAL_BALANCE',
    ELECTION_BASED = 'ELECTION_BASED'
}
/**
* @export
* @enum {string}
*/
export enum IAvailableBalanceTypePropertyDtoAvailableBalanceTypeStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IAvailableBalanceTypePropertyDto interface.
 */
export function instanceOfIAvailableBalanceTypePropertyDto(value: object): value is IAvailableBalanceTypePropertyDto {
    return true;
}

export function IAvailableBalanceTypePropertyDtoFromJSON(json: any): IAvailableBalanceTypePropertyDto {
    return IAvailableBalanceTypePropertyDtoFromJSONTyped(json, false);
}

export function IAvailableBalanceTypePropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAvailableBalanceTypePropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'available_balance_type': json['available_balance_type'] == null ? undefined : json['available_balance_type'],
        'available_balance_type_state': json['available_balance_type_state'] == null ? undefined : json['available_balance_type_state'],
    };
}

export function IAvailableBalanceTypePropertyDtoToJSON(json: any): IAvailableBalanceTypePropertyDto {
    return IAvailableBalanceTypePropertyDtoToJSONTyped(json, false);
}

export function IAvailableBalanceTypePropertyDtoToJSONTyped(value?: IAvailableBalanceTypePropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'available_balance_type': value['available_balance_type'],
        'available_balance_type_state': value['available_balance_type_state'],
    };
}

